import { useCallback } from 'react';
import { nicService } from './services/nicService';
export var useNicService = function () {
    var initEngagement = useCallback(function () { return nicService.initEngagement(); }, []);
    var startSession = useCallback(function () { return nicService.startSession(); }, []);
    var endSession = useCallback(function () { return nicService.endSession(); }, []);
    var changeAgentStatus = useCallback(function (state, reason) {
        return nicService.changeAgentStatus(state, reason);
    }, []);
    var holdResumeCall = useCallback(function (callIndex) { return nicService.holdResumeCall(callIndex); }, []);
    var muteUnmuteCall = useCallback(function (callIndex) { return nicService.muteUnmuteCall(callIndex); }, []);
    var acceptIncomingCall = useCallback(function (contactID) { return nicService.acceptIncomingCall(contactID); }, []);
    var endCall = useCallback(function (callIndex) { return nicService.endCall(callIndex); }, []);
    var rejectIncomingCall = useCallback(function (callIndex) { return nicService.rejectIncomingCall(callIndex); }, []);
    var dialOutboundCall = useCallback(function (dialPhoneRequest) {
        return nicService.dialOutboundCall(dialPhoneRequest);
    }, []);
    var consultAgent = useCallback(function (agentId) { return nicService.consultAgent(agentId); }, []);
    var holdCurrentAndConsultAgent = useCallback(function (agentId, callIndex) {
        return nicService.holdCurrentAndConsultAgent(agentId, callIndex);
    }, []);
    var holdCurrentAndDialPhone = useCallback(function (phoneNumber, skillId, callIndex) {
        return nicService.holdCurrentAndDialPhone(phoneNumber, skillId, callIndex);
    }, []);
    var sendDtmfTone = useCallback(function (digit) { return nicService.sendDtmfTone(digit); }, []);
    var holdCurrentAndDialSkill = useCallback(function (skillId, callIndex) {
        return nicService.holdCurrentAndDialSkill(skillId, callIndex);
    }, []);
    var transferCall = useCallback(function () { return nicService.transferCall(); }, []);
    var startConferenceCall = useCallback(function () { return nicService.startConferenceCall(); }, []);
    var leaveConferenceCall = useCallback(function (callIndex) { return nicService.leaveConferenceCall(callIndex); }, []);
    var acceptChat = useCallback(function (contactId) { return nicService.acceptChat(contactId); }, []);
    var rejectChat = useCallback(function (contactId) { return nicService.rejectChat(contactId); }, []);
    var endChat = useCallback(function (contactId) { return nicService.endChat(contactId); }, []);
    var sendChatMessage = useCallback(function (contactId, text) {
        return nicService.sendChatMessage(contactId, text);
    }, []);
    var fetchUnavailableCodes = useCallback(function () { return nicService.fetchUnavailableCodes(); }, []);
    var loadDirectoryData = useCallback(function (directoryRequest) {
        return nicService.loadDirectoryData(directoryRequest);
    }, []);
    return {
        initEngagement: initEngagement,
        startSession: startSession,
        endSession: endSession,
        holdResumeCall: holdResumeCall,
        muteUnmuteCall: muteUnmuteCall,
        acceptIncomingCall: acceptIncomingCall,
        endCall: endCall,
        rejectIncomingCall: rejectIncomingCall,
        dialOutboundCall: dialOutboundCall,
        consultAgent: consultAgent,
        holdCurrentAndConsultAgent: holdCurrentAndConsultAgent,
        holdCurrentAndDialPhone: holdCurrentAndDialPhone,
        sendDtmfTone: sendDtmfTone,
        holdCurrentAndDialSkill: holdCurrentAndDialSkill,
        transferCall: transferCall,
        startConferenceCall: startConferenceCall,
        leaveConferenceCall: leaveConferenceCall,
        acceptChat: acceptChat,
        rejectChat: rejectChat,
        endChat: endChat,
        sendChatMessage: sendChatMessage,
        changeAgentStatus: changeAgentStatus,
        fetchUnavailableCodes: fetchUnavailableCodes,
        loadDirectoryData: loadDirectoryData
    };
};
